import { Mapper } from "../../../../base/utils/mapper";
import { AgreementModel } from "../../../../domain/models/configuration/agreement.model";
import { AgreementEntity } from "../entities/agreement.entity";

export class AgreementImplementationRepositoryMapper extends Mapper<AgreementEntity, AgreementModel> {
    mapFrom(param: AgreementEntity): AgreementModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: AgreementModel): AgreementEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}